export function fileUploadBuilderUI(ret) {
  return {
    ...ret
  };
}
export function triggerEmailBuilderUI(ret) {
  return {
    ...ret
  };
}
